import apiService from "../../services/apiService";

export default {
  name: "Projects",
  data: () => {
    return {
      projectsTitle: {},
      projects: []
    };
  },
  methods: {
    getImage(url) {
      return `https://strapi-image.herokuapp.com${url}`;
    }
  },
  async created() {
    this.projectsTitle = await apiService.getProjectTitle();
    this.projects = await apiService.getProjects();
  }
}